module.exports = __webpack_public_path__ + "img/6.c2e4a9e9.jpg";